import type { Theme, ThemeOptions } from '@mui/material/styles';

/** No special Radio styling yet. */
export function radioThemeComponents(_theme: Theme): ThemeOptions['components'] {
  return {};
}
